module.exports = __webpack_public_path__ + "1d1f1e3b1bbf75f1bc0852b228e735e9.pdf";